import { Component, OnInit, ViewChild } from '@angular/core';
import { Documento } from '../models/documento';
import { Filtro } from '../models/filtro';
import { MatPaginator, PageEvent } from '@angular/material';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { DocumentosService } from '../services/documentos.service';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-anexos',
  templateUrl: './anexos.component.html',
  styleUrls: ['./anexos.component.scss']
})
export class AnexosComponent implements OnInit {

  anexosFiltrados: Documento[] = [];
  carregando = true;
  campoOrdenacao = 'titulo';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'titulo', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  tipos: any[] = [{ id: 0, nome: 'Contato' }];
  tipoSelecionado = 0;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private router: Router,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private documentoService: DocumentosService,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarAnexos();
  }

  ordena(campo) {
    if (campo) {

      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarAnexos();
    this.paginator.firstPage();
  }

  buscarAnexos() {
    this.carregandoService.mostra('buscaAnexos');
    this.carregando = true;

    this.documentoService.consultarDocumentosComPaginacao(this.tipoSelecionado, this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
      this.anexosFiltrados = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscaAnexos');
    }, (erro) => {
      this.carregandoService.esconde('buscaAnexos');
      this.notificacaoService.erro(erro);
    });
  }

  novoAnexo() {
    this.router.navigate(['/configuracoes/anexos/novo'], { state: { tipo: this.tipoSelecionado, tipoDescricao: this.tipos.find(p => p.id === this.tipoSelecionado).nome } });
  }

  editarAnexo(anexo) {
    this.router.navigate(['/configuracoes/anexos/editar', anexo.id], { state: { tipo: this.tipoSelecionado, tipoDescricao: this.tipos.find(p => p.id === this.tipoSelecionado).nome } });
  }

  excluirAnexo(anexo: Documento) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Anexo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiAnexo');
        this.documentoService.excluir(anexo.id).subscribe(resp => {
          this.notificacaoService.sucesso('Anexo excluído com sucesso!!!');
          this.carregandoService.esconde('excluiAnexo');
          this.filtra();

        }, (erro) => {
          this.carregandoService.esconde('excluiAnexo');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
       this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarAnexos();
  }

  ngOnDestroy(): void {}
}